import React from "react";
import { Routes, Route } from "react-router-dom";
import { PartnerProvider } from "../context/PartnerContext";

// pages …
import Form from "../pages/Form";
import SlotPage from "../pages/SlotPage";
import BookingDetails from "../pages/BookingDetails";
import AppointmentConfirmation from "../pages/AppointmentConfirmation";
import RequestSlotPage from "../pages/RequestSlotPage";
import RequestBookingDetails from "../pages/RequestBookingDetails";
import TherapistPage from "../pages/therapistPage";
import TherapistSlot from "../pages/therapistSlot";
import SlotPageFreelancer from "../pages/SlotPageFreelancer";
import FreelanceBookingDetails from "../pages/FreelanceBookingDetails";

const PartnerRouter = () => (
    <PartnerProvider>
        <Routes>
            <Route path="form" element={<Form />} />
            <Route path="booking-slot" element={<SlotPage />} />  {/* ✅ fixed */}
            <Route path="booking-detail" element={<BookingDetails />} />
            <Route path="appointment-confirmation" element={<AppointmentConfirmation />} />
            <Route path="request-slot" element={<RequestSlotPage />} />
            <Route path="request-booking-detail" element={<RequestBookingDetails />} />
            <Route path="therapist-slot/:therapistId" element={<TherapistSlot />} />
            <Route path="therapistPage" element={<TherapistPage />} />
            <Route path="slot-page-freelancer" element={<SlotPageFreelancer />} />
            <Route path="freelance-booking-detail" element={<FreelanceBookingDetails />} />
        </Routes>

    </PartnerProvider>
);

export default PartnerRouter;
